var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"formatter":function (value) { return (value + "%"); }},on:{"change":_vm.onChange},model:{value:(_vm.rate),callback:function ($$v) {_vm.rate=$$v},expression:"rate"}})}
var staticRenderFns = []

export { render, staticRenderFns }